export * from './KonturInstallIcon';
export * from './KonturInstallIcon16Light';
export * from './KonturInstallIcon16Regular';
export * from './KonturInstallIcon16Solid';
export * from './KonturInstallIcon20Light';
export * from './KonturInstallIcon20Regular';
export * from './KonturInstallIcon20Solid';
export * from './KonturInstallIcon24Regular';
export * from './KonturInstallIcon24Solid';
export * from './KonturInstallIcon32Regular';
export * from './KonturInstallIcon64Regular';
